import { configureStore } from "@reduxjs/toolkit";
import { useSelector, TypedUseSelectorHook } from "react-redux";
import ucuxRemarksReducer from "./app.pss/features/aprs-ucux/controllers/usePssAprsUcux.Remarks";

import {
  StarterStoreSlices,
  starterReducers,
} from "./app.starter/configs/_starter.store.slice";
import {
  OtherStoreSlices,
  otherReducers,
} from "./app.other/configs/_other.store.slice";
import {
  CoreUiStoreSlices,
  coreuiReducers,
} from "./app.coreui/configs/_coreui.store.slice";
import {
  PssStoreSlices,
  pssReducers,
  pssApiMiddlewares,
} from "./app.pss/configs/_pss.store.slice";

//eslint:disable-next-line:no-empty-interface
export interface ReduxStore
  extends PssStoreSlices,
    StarterStoreSlices,
    OtherStoreSlices,
    CoreUiStoreSlices {
  additionalProp?: unknown;
}

const store = configureStore({
  reducer: {
    ...starterReducers,
    ...otherReducers,
    ...coreuiReducers,
    ...pssReducers,
      ucuxRemarks: ucuxRemarksReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...pssApiMiddlewares),
  devTools: true,
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// https://react-redux.js.org/using-react-redux/static-typing#typing-the-useselector-hook
export const useTypedSelector: TypedUseSelectorHook<ReduxStore> = useSelector;
